
// import React, { useState, useEffect } from 'react';
// import '../../css/VMSMOnitoring.css';
// import RtspPlayer from 'components/RtspPlayer';
// import { getWebsocketHost, settingsConfig } from 'utils/commonFunc';

// const VMSMonitoring = () => {
//     const [activeTab, setActiveTab] = useState('문자식');
//     const [playingVideos, setPlayingVideos] = useState(new Set());
//     const [videoUrls, setVideoUrls] = useState({});

//     const tabs = ['문자식', '혼합식', '도형식'];

//     // 8개의 영상 영역 생성
//     const videoAreas = Array.from({ length: 8 }, (_, index) => ({
//         id: index + 1,
//         title: '광고 중앙역 삼거리'
//     }));

//     // URL 생성 함수
//     const generateVideoUrl = (videoId) => {
//         const serviceConfig = settingsConfig();
//         return `${getWebsocketHost('/websocket/stream', 8009)}?id=1&width=${serviceConfig.cctvWidth}&height=${serviceConfig.cctvHeight}&fps=${serviceConfig.cctvFps}`;
//     };

//     // 영상 재생/정지 핸들러
//     const handleVideoClick = (videoId) => {
//         setPlayingVideos(prev => {
//             const newSet = new Set(prev);
//             if (newSet.has(videoId)) {
//                 newSet.delete(videoId); // 재생 중이면 정지
//                 // URL도 제거
//                 setVideoUrls(prevUrls => {
//                     const newUrls = { ...prevUrls };
//                     delete newUrls[videoId];
//                     return newUrls;
//                 });
//             } else {
//                 newSet.add(videoId); // 정지 중이면 재생
//                 // URL 생성
//                 setVideoUrls(prevUrls => ({
//                     ...prevUrls,
//                     [videoId]: generateVideoUrl(videoId)
//                 }));
//             }
//             return newSet;
//         });
//     };

//     return (
//         <div className="vms-container">
//             <h1 className="vms-title">VMS 웹카메라 모니터링</h1>

//             {/* 탭 메뉴 */}
//             <div className="tab-menu">
//                 {tabs.map((tab) => (
//                     <button
//                         key={tab}
//                         className={`tab-button ${activeTab === tab ? 'active' : ''}`}
//                         onClick={() => setActiveTab(tab)}
//                     >
//                         {tab}
//                     </button>
//                 ))}
//             </div>

//             {/* 영상 그리드 */}
//             <div className="video-grid">
//                 {videoAreas.map((video) => (
//                     <div key={video.id} className="video-item">
//                         <div className="video-header">
//                             <span className="video-title">{video.title}</span>
//                         </div>
//                         <div 
//                             className="video-area"
//                             onClick={() => handleVideoClick(video.id)}
//                         >
//                             {playingVideos.has(video.id) ? (
//                                 <div className="rtsp-player-container">
//                                     <RtspPlayer 
//                                         url={videoUrls[video.id]} 
//                                         fps={settingsConfig().cctvFps}
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="video-placeholder-container">
//                                     <span className="video-placeholder">영상영역</span>
//                                     <span className="video-click-hint">클릭하여 재생</span>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default VMSMonitoring;


import React, { useState, useEffect } from 'react';
import '../../css/VMSMOnitoring.css';
import RtspPlayer from 'components/RtspPlayer';
import { getWebsocketHost, settingsConfig } from 'utils/commonFunc';
import ApiService from 'services/ApiService';

const VMSMonitoring = () => {
    const [activeTab, setActiveTab] = useState('문자식');
    const [playingVideos, setPlayingVideos] = useState(new Set());
    const [videoUrls, setVideoUrls] = useState({});
    const [vmsData, setVmsData] = useState({});
    const [loading, setLoading] = useState(true);
    const [expandedVideo, setExpandedVideo] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(8); // 한 페이지에 8개씩

    const tabs = ['문자식', '혼합식', '도형식'];

    // VMS 데이터 가져오기
    const fetchVmsData = async () => {
        try {
            setLoading(true);
            const response = await ApiService.get("newdashboard/afterpack/GetVms");
            
            if (response.data && Array.isArray(response.data)) {
                // 타입별로 데이터 직접 매핑
                const groupedData = {
                    '문자식': [],
                    '혼합식': [],
                    '도형식': []
                };

                response.data.forEach(typeData => {
                    if (typeData.rows && Array.isArray(typeData.rows)) {
                        switch (typeData.type) {
                            case '2':
                                groupedData['문자식'] = typeData.rows;
                                break;
                            case '4':
                                groupedData['혼합식'] = typeData.rows;
                                break;
                            case '5':
                            case '6':
                            case '7':
                                groupedData['도형식'] = [...groupedData['도형식'], ...typeData.rows];
                                break;
                        }
                    }
                });

                setVmsData(groupedData);
            }
        } catch (error) {
            console.error('VMS 데이터 가져오기 실패:', error);
        } finally {
            setLoading(false);
        }
    };

    // 컴포넌트 마운트 시 데이터 가져오기
    useEffect(() => {
        fetchVmsData();
    }, []);

    // 탭 변경 시 페이지를 1로 초기화
    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);

    // URL 생성 함수 (웹소켓 사용, ID만 변경)
    const generateVideoUrl = (videoId) => {
        const serviceConfig = settingsConfig();
        return `${getWebsocketHost('/websocket/stream', 8009)}?id=${videoId}&width=${serviceConfig.cctvWidth}&height=${serviceConfig.cctvHeight}&fps=${serviceConfig.cctvFps}`;
    };

    // 영상 재생/정지 핸들러
    const handleVideoClick = (videoId) => {
        // 확대된 상태면 확대 해제
        if (expandedVideo === videoId) {
            setExpandedVideo(null);
            return;
        }

        setPlayingVideos(prev => {
            const newSet = new Set(prev);
            if (newSet.has(videoId)) {
                newSet.delete(videoId);
                setVideoUrls(prevUrls => {
                    const newUrls = { ...prevUrls };
                    delete newUrls[videoId];
                    return newUrls;
                });
            } else {
                newSet.add(videoId);
                setVideoUrls(prevUrls => ({
                    ...prevUrls,
                    [videoId]: generateVideoUrl(videoId)
                }));
            }
            return newSet;
        });
    };

    // 영상 확대/축소 핸들러
    const handleVideoExpand = (videoId, e) => {
        e.stopPropagation();
        
        if (expandedVideo === videoId) {
            setExpandedVideo(null);
        } else {
            setExpandedVideo(videoId);
        }
    };

    // 현재 탭의 전체 데이터 가져오기
    const getCurrentTabAllData = () => {
        return vmsData[activeTab] || [];
    };

    // 현재 페이지의 데이터 가져오기
    const getCurrentPageData = () => {
        const allData = getCurrentTabAllData();
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return allData.slice(startIndex, endIndex);
    };

    // 페이지네이션 정보 계산
    const getPaginationInfo = () => {
        const allData = getCurrentTabAllData();
        const totalItems = allData.length;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        
        return {
            totalItems,
            totalPages,
            currentPage,
            itemsPerPage
        };
    };

    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // 페이지 버튼 렌더링
    const renderPaginationButtons = () => {
        const { totalPages } = getPaginationInfo();
        const buttons = [];
        
        // 이전 버튼
        buttons.push(
            <button
                key="prev"
                className={`pagination-button ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                이전
            </button>
        );

        // 페이지 번호 버튼들
        for (let i = 1; i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        // 다음 버튼
        buttons.push(
            <button
                key="next"
                className={`pagination-button ${currentPage === totalPages ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                다음
            </button>
        );

        return buttons;
    };

    if (loading) {
        return (
            <div className="vms-container">
                <div className="loading">데이터를 불러오는 중...</div>
            </div>
        );
    }

    const paginationInfo = getPaginationInfo();

    return (
        <div className="vms-container">
            <h1 className="vms-title">VMS 웹카메라 모니터링</h1>

            {/* 탭 메뉴 */}
            <div className="tab-menu">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab} ({vmsData[tab]?.length || 0})
                    </button>
                ))}
            </div>

            {/* 페이지네이션 정보 */}
            <div className="pagination-info">
                총 {paginationInfo.totalItems}개 중 {((currentPage - 1) * itemsPerPage) + 1}-{Math.min(currentPage * itemsPerPage, paginationInfo.totalItems)}개 표시
            </div>

            {/* 영상 그리드 */}
            <div className={`video-grid ${expandedVideo ? 'has-expanded' : ''}`}>
                {getCurrentPageData().map((video) => (
                    <div 
                        key={video.id} 
                        className={`video-item ${expandedVideo === video.id ? 'expanded' : ''} ${expandedVideo && expandedVideo !== video.id ? 'dimmed' : ''}`}
                    >
                        <div className="video-header">
                            <span className="video-title">{video.nm}</span>
                            {playingVideos.has(video.id) && (
                                <button 
                                    className="expand-button"
                                    onClick={(e) => handleVideoExpand(video.id, e)}
                                    title={expandedVideo === video.id ? "원래 크기로" : "확대"}
                                >
                                    {expandedVideo === video.id ? '⤢' : '⤡'}
                                </button>
                            )}
                        </div>
                        <div
                            className="video-area"
                            onClick={() => handleVideoClick(video.id)}
                        >
                            {playingVideos.has(video.id) ? (
                                <div className="rtsp-player-container">
                                    <RtspPlayer
                                        url={videoUrls[video.id]}
                                        fps={settingsConfig().cctvFps}
                                    />
                                </div>
                            ) : (
                                <div className="video-placeholder-container">
                                    <span className="video-placeholder">영상영역</span>
                                    <span className="video-click-hint">클릭하여 재생</span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* 페이지네이션 버튼 */}
            {paginationInfo.totalPages > 1 && (
                <div className="pagination-container">
                    <div className="pagination-buttons">
                        {renderPaginationButtons()}
                    </div>
                </div>
            )}

            {/* 확대된 영상이 있을 때 배경 클릭으로 닫기 */}
            {expandedVideo && (
                <div 
                    className="expanded-overlay"
                    onClick={() => setExpandedVideo(null)}
                />
            )}
        </div>
    );
};

export default VMSMonitoring;